import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../../api/client";
import { registerPushSubscription } from "utils/push";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { BRAND_NAME } from "config/brand";

// Images
import bgImage from "assets/images/home-decor-4.jpeg";

const PROFILE_KEY = "solvit_profile";
const TOKEN_KEY = "solvit_auth_token";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); // aktuell nur Platzhalter
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const key = email.trim().toLowerCase();
    if (!key) {
      setError("Bitte E-Mail eingeben.");
      return;
    }
    if (!password) {
      setError("Bitte Passwort eingeben.");
      return;
    }

    try {
      setLoading(true);
      const res = await apiFetch("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email: key, password }),
      });

      // Backend liefert: { accessToken, user }
      localStorage.setItem(TOKEN_KEY, res.accessToken);

      const customer = res.user?.customer;
      const profile = {
        customerNumber: customer?.customerNumber || (res.user?.role === "ADMIN" ? "ADMIN" : ""),
        companyName: customer?.companyName || (res.user?.role === "ADMIN" ? BRAND_NAME : ""),
        contactName: customer?.contactName || "",
        street: customer?.street || "",
        zip: customer?.zip || "",
        city: customer?.city || "",
        country: customer?.country || "Deutschland",
        vatId: customer?.vatId || "",
        accountHolder: customer?.accountHolder || "",
        iban: customer?.iban || "",
        bic: customer?.bic || "",
        avatarUrl: res.user?.avatarUrl || "",
        role: (res.user?.role || "customer").toLowerCase(),
      };

      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
      window.dispatchEvent(new Event("solvit-profile-updated"));
      await registerPushSubscription().catch(() => null);

      navigate("/dashboard", { replace: true });
    } catch (e) {
      if (e?.code === "ACCESS_BLOCKED") {
        setError(e?.message || "Dein Zugang ist aktuell gesperrt. Bitte kontaktiere den Support.");
      } else {
        setError(e?.message || "Login fehlgeschlagen");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox pt={4} pb={3} px={3} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" mb={1}>
            Login
          </MDTypography>
        </MDBox>

        <MDBox pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="E-Mail"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Passwort"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>

            {error && (
              <MDBox mb={1}>
                <MDTypography variant="caption" color="error">
                  {error}
                </MDTypography>
              </MDBox>
            )}

            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                {loading ? "Einloggen..." : "Einloggen"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SignIn;
